import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitCard = ({ benefit }) => {
  return (
    <div className="p-6 rounded-lg bg-card border border-border">
      <div className="flex items-start gap-4">
        <div className="p-3 rounded-lg bg-primary/10">
          <Icon name={benefit?.icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-foreground mb-2">
            {benefit?.title}
          </h3>
          <p className="text-sm text-muted-foreground">{benefit?.description}</p>
        </div>
      </div>
    </div>
  );
};

export default BenefitCard;